import { CustomHeaderComponent } from '../../components/custom-header/custom-header.component';
import { CreateUpdateProductsComponent } from '../../products/create-update-products/create-update-products.component';
import { ProductsComponent } from '../../products/products.component';
import { ProductsLoaderService } from '../../products/service/products-loader.service';

export const PRODUCTS_ROUTES = [
    {
        path: 'product/product-list',
        component: ProductsComponent,
        data: {
			subComponentShow: false,
			breadcrumbComponent: CustomHeaderComponent,
			breadcrumbComponentData: {
				title: 'Product List'
			}
        }
    },
    {
        path: 'product/create',
        component: CreateUpdateProductsComponent,
        data: {
            subComponentShow: false
        },
        canActivate: [ProductsLoaderService]
    },
    {
        path: 'product/edit/:prodId',
        component: CreateUpdateProductsComponent,
        data: {
            subComponentShow: false
        },
        canActivate: [ProductsLoaderService],
    },
];